import { getDocument } from '@atlaskit/browser-apis';
export function isEntrySmartAnswersInSearch(entry) {
  var _ref = entry.data,
    elementName = _ref.elementName;
  if (!elementName || elementName === 'START') {
    return false;
  }
  var doc = getDocument();
  if (!doc) {
    return false;
  }
  var smartAnswersElement = doc.getElementById('search-page-smart-answers');
  if (!smartAnswersElement) {
    return false;
  }
  var entryDOMElement = doc.querySelector(elementName);
  if (!entryDOMElement) {
    return false;
  }
  return smartAnswersElement.contains(entryDOMElement);
}